import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScaiJsonEditorComponent } from '../json-editor-component';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { NgJsonEditorModule } from 'ang-jsoneditor';
import { TranslateModule } from '@ngx-translate/core';

 
@NgModule({
  declarations: [ScaiJsonEditorComponent],
  imports: [
    CommonModule,
	FormsModule,  
    ButtonModule,
    NgJsonEditorModule,
    TranslateModule
  ],
  exports: [ScaiJsonEditorComponent]
})
export class JsonEditorModule {}